"use client";

import { c as _c } from "react/compiler-runtime";
import DropsListItemDeleteDropModal from "@/components/drops/view/item/options/delete/DropsListItemDeleteDropModal";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { TrashIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";
import { Tooltip } from "react-tooltip";
interface WaveDropActionsOptionsProps {
  readonly drop: ApiDrop;
}
const WaveDropActionsOptions: React.FC<WaveDropActionsOptionsProps> = t0 => {
  const $ = _c(17);
  const {
    drop
  } = t0;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.stopPropagation();
      setIsDeleteModalOpen(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `delete-${drop.id}`;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TrashIcon className="tw-flex-shrink-0 tw-w-5 tw-h-5" />;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t2) {
    t4 = <button onClick={t1} className="tw-text-iron-400 desktop-hover:hover:tw-text-rose-400 tw-cursor-pointer tw-transition-colors tw-bg-transparent tw-border-0 tw-px-2" aria-label="Delete drop" data-tooltip-id={t2}>{t3}</button>;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `delete-${drop.id}`;
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    t7 = <span className="tw-text-xs">Delete</span>;
    $[4] = t6;
    $[5] = t7;
  } else {
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t5) {
    t8 = <Tooltip id={t5} place="top" style={t6}>{t7}</Tooltip>;
    $[6] = t5;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== drop || $[9] !== isDeleteModalOpen) {
    t9 = isDeleteModalOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-50" elementRole="dialog" onClicked={_temp}><DropsListItemDeleteDropModal drop={drop} closeModal={() => setIsDeleteModalOpen(false)} /></CommonAnimationOpacity>;
    $[8] = drop;
    $[9] = isDeleteModalOpen;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t9) {
    t10 = <CommonAnimationWrapper mode="sync" initial={true}>{t9}</CommonAnimationWrapper>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t4 || $[15] !== t8) {
    t11 = <>{t4}{t8}{t10}</>;
    $[13] = t10;
    $[14] = t4;
    $[15] = t8;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
};
export default WaveDropActionsOptions;
function _temp(e_0) {
  return e_0.stopPropagation();
}